// Tracks the open-modal stack so document-level Escape handlers fire only on
// the topmost dialog. Without this, two stacked dialogs (e.g. confirm-action
// over launch-test) tear each other down on a single Esc press.
//
// Each dialog component pushes itself in ngOnInit and pops in ngOnDestroy; its
// HostListener bails early if it isn't on top.

const stack: object[] = []

export function pushModal(handler: object): void {
  stack.push(handler)
}

export function popModal(handler: object): void {
  const idx = stack.lastIndexOf(handler)
  if (idx >= 0) stack.splice(idx, 1)
}

export function isTopmostModal(handler: object): boolean {
  return stack.length > 0 && stack[stack.length - 1] === handler
}
